// Tremor Raw Divider [v0.0.0]
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { cx } from "../../lib/utils";
const Divider = React.forwardRef((_a, forwardedRef) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement("div", Object.assign({ ref: forwardedRef, className: cx(
        // base
        "onvo-mx-auto onvo-my-6 onvo-flex onvo-w-full onvo-items-center onvo-justify-between onvo-gap-3 onvo-text-sm", 
        // text color
        "onvo-text-gray-500 dark:onvo-text-gray-500", className) }, props), children ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cx(
            // base
            "onvo-h-[1px] onvo-w-full", 
            // background color
            "onvo-bg-gray-200 dark:onvo-bg-gray-800") }),
        React.createElement("div", { className: "onvo-whitespace-nowrap onvo-text-inherit" }, children),
        React.createElement("div", { className: cx(
            // base
            "onvo-h-[1px] onvo-w-full", 
            // background color
            "onvo-bg-gray-200 dark:onvo-bg-gray-800") }))) : (React.createElement("div", { className: cx(
        // base
        "onvo-h-[1px] onvo-w-full", 
        // backround color
        "onvo-bg-gray-200 dark:onvo-bg-gray-700") }))));
});
Divider.displayName = "Divider";
export { Divider };
//# sourceMappingURL=Divider.js.map